import { X } from "lucide-react-native";
import { AnimatedSaveBookmark, IconButton } from "@louise/moon-ui";
import { EMBER } from "../../onboarding/theme";

export type ArticleReaderActionsProps = {
  bookmarked: boolean;
  onToggleFavorite: () => void;
  onClose: () => void;
  size?: number;
  savedLabel: string;
  saveAccessibilityLabel: string;
  removeAccessibilityLabel: string;
  closeAccessibilityLabel: string;
};

/** The shared save/close action group used by both reader action placements. */
export function ArticleReaderActions({
  bookmarked,
  onToggleFavorite,
  onClose,
  size = 28,
  savedLabel,
  saveAccessibilityLabel,
  removeAccessibilityLabel,
  closeAccessibilityLabel,
}: ArticleReaderActionsProps) {
  const iconSize = size - 14;

  return (
    <>
      <AnimatedSaveBookmark
        bookmarked={bookmarked}
        onPress={onToggleFavorite}
        size={size}
        savedLabel={savedLabel}
        saveAccessibilityLabel={saveAccessibilityLabel}
        removeAccessibilityLabel={removeAccessibilityLabel}
        activeColor={EMBER.colors.warm}
        inactiveIconColor={EMBER.colors.textLight}
        activeBackgroundColor={`${EMBER.colors.warm}22`}
      />
      <IconButton
        onPress={onClose}
        hitSlop={8}
        size={size}
        surface="soft"
        backgroundColor="rgba(0, 0, 0, 0.05)"
        pressedBackgroundColor="rgba(0, 0, 0, 0.05)"
        pressedOpacity={1}
        accessibilityLabel={closeAccessibilityLabel}
      >
        <X size={iconSize} color={EMBER.colors.textLight} />
      </IconButton>
    </>
  );
}

export default ArticleReaderActions;
